import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';

import { CustomsNonDelivery } from '../../../../enums/customs-non-delivery';

import { CustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';

import commonStyle from '../common-style.module.less';
import messages from '../messages';

export const NonDeliveryDropdown = () => {
  const { nonDelivery, updateNonDelivery }: CustomsContextValue = useContext(CustomsContext);
  const selectedNonDelivery = nonDelivery ? CustomsNonDelivery[nonDelivery] : undefined;

  return (
    <DropdownMenu
      {...testId('customs-widget-nondelivery-dropdown')}
      className={commonStyle['standard-dropdown']}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      value={selectedNonDelivery && selectedNonDelivery.name}
      variant='form'
    >
      <DropdownMenuToggler className={commonStyle['standard-dropdown']}>
        {selectedNonDelivery ? (
          <FormattedMessage {...selectedNonDelivery.translation} />
        ) : (
          <FormattedMessage {...messages.defaultNonDelivery} />
        )}
      </DropdownMenuToggler>
      {Object.values(CustomsNonDelivery).map((nonDeliveryEnum) => (
        <DropdownMenuItem
          key={nonDeliveryEnum.name}
          onClick={() => updateNonDelivery(nonDeliveryEnum.name)}
          selected={selectedNonDelivery?.name === nonDeliveryEnum.name}
        >
          <FormattedMessage {...nonDeliveryEnum.translation} />
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
